import React, { useRef, useEffect } from 'react';
import settings from '../../../settings';
import { updateUserDataAfterLogin } from '../../../store/calls';
import api from '../../../store/api';
import {toggleGlobalLoader} from "../../../store/actions/session";

export const handleGoogleLoginRequest = (data, onSuccess, onFailure) => {
	toggleGlobalLoader(true)
	return api
		.post('/auth/google-login/', data)
		.then((res) => {
			let token = res.data.tokens.access;
			let userData = updateUserDataAfterLogin(token);
			return onSuccess && onSuccess(userData);
		})
		.catch((err) => {
			return onFailure && onFailure(err);
		})
		.finally(() => toggleGlobalLoader(false))
};

export const runGoogleAuthLoadRoutine = ({ ref, onSuccess, onFailure }) => {
	if (window.google) {
		window.google.accounts.id.initialize({
			client_id: settings.googleAuthClientId,
			ux_mode: 'popup',
			callback: (data) => {
				return handleGoogleLoginRequest(data, onSuccess, onFailure);
			},
		});

		window.google.accounts.id.renderButton(ref.current, {
			type: 'standard',
			theme: 'outline',
			size: 'large',
		});
	}
};

function GoogleLoginButton({ successCallback, failureCallback, className }) {
	const googleLoginRef = useRef(null);
	useEffect(() => {
		runGoogleAuthLoadRoutine({
			ref: googleLoginRef,
			onSuccess: successCallback,
			onFailure: failureCallback,
		});
	});

	return <div className={className}>
		<div ref={googleLoginRef} data-testid="google-login-button" />
	</div>
}

export default GoogleLoginButton;
